import postcssShortBorder from 'postcss-short-border';
import postcssShortBorderRadius from 'postcss-short-border-radius';
import postcssShortColor from 'postcss-short-color';
import postcssShortFontSize from 'postcss-short-font-size';
import postcssShortOverflow from 'postcss-short-overflow';
import postcssShortPosition from 'postcss-short-position';
import postcssShortSize from 'postcss-short-size';
import postcssShortSpacing from 'postcss-short-spacing';
import postcssFontWeights from 'postcss-font-weights';

export default {
	border:       postcssShortBorder,
	borderRadius: postcssShortBorderRadius,
	color:        postcssShortColor,
	fontSize:     postcssShortFontSize,
	overflow:     postcssShortOverflow,
	position:     postcssShortPosition,
	size:         postcssShortSize,
	spacing:      postcssShortSpacing,
	fontWeights:  postcssFontWeights
};
